import {
  Component,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular/ui/tree-view';
import { navigation } from '../../../app-navigation';

import * as events from 'devextreme/events';
import { StorageService } from '../../services/storage.service';
import { ParametriLogin } from 'src/app/models/parametri-login';
import { NOME_MODULO_BARCODE } from 'src/app/consts/const';

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss'],
  imports: [DxTreeViewComponent],
  standalone: true,
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  private elementRef = inject(ElementRef);
  private storService = inject(StorageService);

  @ViewChild(DxTreeViewComponent, { static: true })
  menu: DxTreeViewComponent;

  @Output()
  selectedItemChanged = new EventEmitter<string>();

  @Output()
  openMenu = new EventEmitter<any>();

  private _selectedItem: string;
  @Input()
  set selectedItem(value: string) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }

    this.menu.instance.selectItem(value);
  }

  private _items;
  get items() {
    if (!this._items) {
      if (!this._items) {
        this._items = navigation.map((item) => ({
          ...item,
          expanded: !this._compactMode,
        }));
      }

      return this._items;
    }

    return this._items;
  }

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;

    if (!this.menu.instance) {
      return;
    }

    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }

  parLogin: ParametriLogin;

  constructor() {
    this.parLogin = this.storService.paramLoginCorrente;
    this.reloadItems();
  }

  reloadItems() {
    this._items = navigation.filter(
      (item) =>
        (item.text != 'PARAMETRI' || this.parLogin?.mostraGestioneStampe) &&
        item.ruoli.includes(this.storService.utenteCorrente.ruoloString) &&
        (item.modulo == undefined || this.moduleVisible(item.modulo)),
    );
  }

  onItemClick(event) {
    this.selectedItemChanged.emit(event);
  }

  ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, 'dxclick', (e) => {
      this.openMenu.emit(e);
    });
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }

  moduleVisible(nomeModulo: string) {
    return (
      this.storService.permessiCorrente.find(
        (x) => x.nomeModulo == nomeModulo,
      ) != undefined
    );
  }
}
